import React from "react";
import { Select } from "antd/lib";
import { Option } from "antd/lib/mentions";

export const MobileDropdown = ({ events, setActiveEvent }) => {
  const handleChange = (value) => {
    setActiveEvent(value);
  };

  return (
    <Select
      onChange={handleChange}
      defaultValue={events[0]?.name}
      placeholder={events[0]?.name}
    >
      {events.map((_proj) => (
        <Option value={_proj._id}>{_proj.name}</Option>
      ))}
    </Select>
  );
};
